import { useNavigate } from "react-router-dom";
import HomeIntro from "../../components/homeIntro";
import MyButton from "../../components/myButton";
import OurServices from "../../components/ourServices";
import WorkingHours from "../../components/workingHours";
import Section from "../../components/section";
import { scrollToForm } from "../../utils/scrolls";
import "./styles.scss";

export default function Home() {
	const navigate = useNavigate();

	return (
		<div className="home-page">
			<HomeIntro />
			<Section
				id="our-services"
				section="خدماتنا"
				title={
					<label>
						نساعدك على تجهيز <label style={{ color: "var(--primary)" }}>شكواك الإلكترونية</label>
					</label>
				}
				subtitle="خدمة فردية مستقلة لترتيب البيانات وصياغة الطلب بوضوح، دون تقديم استشارات قانونية أو تمثيل رسمي"
				bodyBG="var(--onBackground)"
			>
				<OurServices />
			</Section>
			<Section
				id="working-hours"
				section="ساعات العمل"
				title="نستقبل طلباتك خلال أيام العمل"
				subtitle="الأوقات واضحة ومحددة بتوقيت عُمان، وأي طلب خارجها يتم ترتيبه لأقرب يوم عمل."
			>
				<WorkingHours />
			</Section>
			<Section id="start-now" section="نحن هنا من أجلك" title={<label style={{ color: "var(--primary)" }}>لنبدأ الآن!</label>}>
				<div className="lets-start-container">
					<p className="lets-start-text">ابدأ الآن بخطوة بسيطة: أرسل بياناتك، وسنتواصل معك لمراجعة التفاصيل ومساعدتك في تجهيز مسودة منظمة يمكنك استخدامها بنفسك.</p>
					<div className="lets-start-actions">
						<MyButton className="lets-start-action-btn" onClick={() => scrollToForm(navigate, "#form-card")}>
							اطلب المساعدة الآن
						</MyButton>
					</div>
					<p className="lets-start-subtext">مراجعة أولية للبيانات والتواصل معك في أقرب وقت عمل</p>
				</div>
			</Section>
			<Section
				id="transparency"
				section="الشفافية"
				title={
					<label>
						خدمة محدودة وواضحة تساعدك على <label style={{ color: "var(--primary)" }}>الفهم قبل الإرسال</label>
					</label>
				}
			>
				<div className="transparency-list" dir="rtl">
					<div className="transparency-item">
						<strong>مراجعة منظمة</strong>
						<span>نراجع البيانات التي ترسلها ونساعدك على ترتيب النقاط المهمة قبل متابعة الطلب.</span>
					</div>
					<div className="transparency-item">
						<strong>تواصل مباشر</strong>
						<span>نتواصل معك لمتابعة التفاصيل وتوضيح ما يلزم لإكمال تجهيز المسودة.</span>
					</div>
					<div className="transparency-item">
						<strong>خصوصية البيانات</strong>
						<span>نستخدم بيانات النموذج للتواصل معك ومراجعة طلبك، ولا نطلب كلمات مرور أو بيانات دفع ولا نجمع مدفوعات عبر الموقع.</span>
					</div>
					<div className="transparency-item">
						<strong>تنبيه شفاف</strong>
						<span>الخدمة فردية مستقلة، وليست شركة مرخصة أو مكتب محاماة أو بوابة حكومية أو منصة تجارة إلكترونية لمعالجة الشكاوى.</span>
					</div>
				</div>
			</Section>
		</div>
	);
}
